export default __webpack_public_path__ + "static/media/logoAsambleaHorizontal.bbd47249.webp";